import { render, staticRenderFns } from "./CompetitionDetail.vue?vue&type=template&id=f72108ee&scoped=true&"
import script from "./CompetitionDetail.vue?vue&type=script&lang=js&"
export * from "./CompetitionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72108ee",
  null
  
)

export default component.exports